import { path } from 'ramda';

import { FEATURE_NAME } from './consts';

export const getCanton = path([FEATURE_NAME, 0]);
export const getCantonProp = (name) => path([FEATURE_NAME, 0, name]);
